<template>
  <div v-if="schedule != null">
    <div class="card" v-for="i in schedule.length" :key="i">
      <div class="before">
        <h4>{{ schedule[i - 1].name }}</h4>
        <span
          >{{ schedule[i - 1].timeClose }} -
          {{ schedule[i - 1].timeOpen }}</span
        >
        <span v-if="schedule[i - 1].temperature != undefined"
          >  {{ schedule[i - 1].temperature.state == true ? '('+ schedule[i - 1].temperature.temp + '°C)' : ''}}</span
        >
      </div>
      <div class="after">
        <ul>
          <li>
            <span :class="Su(i - 1)">Su</span>
          </li>
          <li>
            <span :class="Mo(i - 1)">Mo</span>
          </li>
          <li>
            <span :class="Tu(i - 1)">Tu</span>
          </li>
          <li>
            <span :class="We(i - 1)">We</span>
          </li>
          <li>
            <span :class="Th(i - 1)">Th</span>
          </li>
          <li>
            <span :class="Fr(i - 1)">Fr</span>
          </li>
          <li>
            <span :class="Sa(i - 1)">Sa</span>
          </li>
        </ul>
        <vs-switch
          color="success"
          v-model="schedule[i - 1].on"
          :disabled="type != 'edit' ? true : false"
          @click="onDevice(schedule[i - 1].on,schedule[i - 1].id)"
        />
        <PopupAddSchedule
          v-if="type == 'edit'"
          type="Change"
          :device="device"
          :nameSchedule="schedule[i - 1].name"
          :TimeClose="schedule[i - 1].timeClose"
          :TimeOpen="schedule[i - 1].timeOpen"
          :on="schedule[i - 1].on"
          :week="schedule[i - 1].week"
          :temperature="schedule[i - 1].temperature"
          :device_id="schedule[i - 1].device_id"
          :id="schedule[i - 1].id"
          v-on:close-popup="closePopup"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PopupAddSchedule from "./PopupAddSchedule.vue";
export default {
  components: { PopupAddSchedule },
  props: {
    schedule: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "edit",
    },
    device: { type: String, default: "light" },

  },
  computed: {
    Su: function () {
      // console.log(i);
      return (i) => {
        return { active: this.schedule[i].week.Su };
      };
    },
    Mo: function () {
      return (i) => {
        return { active: this.schedule[i].week.Mo };
      };
    },
    Tu: function () {
      return (i) => {
        return { active: this.schedule[i].week.Tu };
      };
    },
    We: function () {
      return (i) => {
        return { active: this.schedule[i].week.We };
      };
    },
    Th: function () {
      return (i) => {
        return { active: this.schedule[i].week.Th };
      };
    },
    Fr: function () {
      return (i) => {
        return { active: this.schedule[i].week.Fr };
      };
    },
    Sa: function () {
      return (i) => {
        return { active: this.schedule[i].week.Sa };
      };
    },
  },
  data() {
    return {};
  },
  methods:{
    onDevice(status,id){
      console.log("click",status,id);
      this.$API.post('schedule/v2.0/active',{
        id:id,
        active:!status
      }).then(()=>{
        console.log('Change Active status');
      })
    },
    closePopup(value){
      this.$emit('close-popup', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  margin: 10px 0 0 0;
  background-color: var(--background-color);
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .before {
    h4 {
      font-size: 1.5rem;
      font-weight: 500;
    }
    span {
      font-size: 1.3rem;
    }
  }
  .after {
    display: flex;
    align-items: center;
    gap: 10px;
    ul {
      display: flex;
      margin: 0;
      gap: 5px;
      li {
        display: inline-flex;
        span {
          font-size: 0.9rem;
          color: #e2e2e2;
        }
        .active {
          color: #32c040;
        }
      }
    }
  }
}
</style>